export default {
  // serverURI: 'https://devapi.rcpanz.com.au/api',
  // serverURI: 'https://uatapi.rcpanz.com.au/api',
  serverURI: 'https://api.rcpanz.com.au/api',
  fixedLayout: false,
  hideLogoOnMobile: false
}



// WEBPACK FOOTER //
// ./src/config/index.js